import Vue from "vue";
import Router from "vue-router";
import Exercises from "./views/Exercises.vue";
import Exercise from "./views/Exercise.vue";
import Olympiads from "./views/Olympiads.vue";
import Olympiad from "./views/Olympiad.vue";
import Login from "./views/Login.vue";
import Resources from "./views/Resources.vue";
import Scoreboard from "./views/Scoreboard.vue";
import Profile from "./views/Profile.vue";
import OlympiadResult from "./views/OlympiadResult.vue";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/exercises",
      name: "exercises",
      component: Exercises
    },
    {
      path: "/exercises/:exerciseId",
      props: true,
      name: "exercise",
      component: Exercise
    },
    {
      path: "/olympiads",
      name: "olympiads",
      component: Olympiads
    },
    {
      path: "/olympiads/:olympiadId",
      props: true,
      name: "Olympiad",
      component: Olympiad
    },
    {
      path: "/olympiad/view/:olympiadId",
      props: true,
      name: "OlympiadResult",
      component: OlympiadResult
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/resources",
      name: "resources",
      component: Resources
    },
    {
      path: "/scoreboard",
      name: "scoreboard",
      component: Scoreboard
    },
    {
      path: "/profile",
      name: "profile",
      component: Profile
    }
  ]
});
